import { Product } from '../../types/Product';

export const calculatePriceDistribution = (products: Product[]) => {
  const ranges = [
    { min: 0, max: 2, label: '0-2€' },
    { min: 2, max: 5, label: '2-5€' },
    { min: 5, max: 10, label: '5-10€' },
    { min: 10, max: 20, label: '10-20€' },
    { min: 20, max: Infinity, label: '+20€' }
  ];

  const distribution = ranges.map(range => {
    const count = products.filter(p => 
      p.current_price >= range.min && p.current_price < range.max
    ).length;
    
    return {
      range: range.label,
      percentage: (count / products.length) * 100
    };
  });

  return distribution;
};

export const calculateCategoryDistribution = (products: Product[]) => {
  const categoryCount = products.reduce((acc, product) => {
    const category = product.category_name;
    acc[category] = (acc[category] || 0) + 1;
    return acc;
  }, {} as Record<string, number>);

  return Object.entries(categoryCount)
    .map(([name, count]) => ({
      name,
      value: (count / products.length) * 100
    }))
    .sort((a, b) => b.value - a.value)
    .slice(0, 5);
};